import { Component, OnInit, OnDestroy } from '@angular/core';
import { HazardCardConfig } from '../nhip-home-map/nhip-home-map-constants';
import { NhipHomeDataService } from '../nhip-home-data.service';
import { UtilsService } from 'src/app/utils/utils.service';
import { isNullOrUndefined } from 'util';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { GisNhipMapComponent } from 'src/app/main/shared/gis-nhip-map/gis-nhip-map.component';
import { NhipHomeMapService } from '../nhip-home-map/nhip-home-map.service';
import { AgricultureMapConstants, LOCATIONS_LATLNG, LOCATIONS_ZOOM } from 'src/app/main/constants/dims-map-constants';

@Component({
  selector: 'app-nhip-home-navbar',
  templateUrl: './nhip-home-navbar.component.html',
  styleUrls: ['./nhip-home-navbar.component.scss']
})
export class NhipHomeNavbarComponent implements OnInit, OnDestroy {
  private subscriptions: any[] = [];

  searchText = '';
  selectedLocation: any = 'India##00cb31c7-2928-4e6d-adcc-443d478c90d6';
  selectedTimeRange: string = 'Last 10 Years';
  earthquakeCount: number = 0;
  cycloneCount: number = 0;
  stateLevelCycloneCount: number | null = null;
  selectedDistrictUUID: string = '';
  selectedDistrictName: string = '';
  overviewConfig: HazardCardConfig[] = [
    {
      key: 'earthquakes',
      title: 'Total Earthquakes',
      value: 29813,
      subText: 'Since 1980',
      icon: 'fa fa-circle',
      iconBg: 'bg-danger-soft'
    },
    {
      key: 'cyclones',
      title: 'Total Cyclones',
      value: 892,
      subText: 'Since 1980',
      icon: 'icon mi-wind-speed',
      iconBg: 'bg-warning-soft'
    },
    {
      key: 'states',
      title: 'Most Effected State',
      value: 'Gujarat, Assam',
      subText: 'By Earthquakes',
      icon: 'fa fa-map-marker',
      iconBg: 'bg-primary-soft'
    },
    {
      key: 'districts',
      title: 'Most Effected State',
      value: 156,
      subText: 'By Cyclone',
      icon: 'fa fa-exclamation-triangle',
      iconBg: 'bg-orange-soft'
    }
  ];
  queryParams: any;
  cycloneStats: any;
  hazardTypes = [
    { label: 'Multi-Hazard', value: 'multiHazard' },
  { label: 'Earthquake', value: 'earthquake' },
  { label: 'Cyclone', value: 'cyclone' },
  { label: 'Location Info', value: 'locationInfo' }
];
  activeHazard = 'earthquake'; // default active
  data = { lat: '', lng: '' };

  constructor(private nhipDataSrv: NhipHomeDataService, private utils: UtilsService, public route: ActivatedRoute, private router: Router, public gisMapComp: GisNhipMapComponent, private nhipMapSrv: NhipHomeMapService) { }

  ngOnInit() {
    //     if (this.isLocationOnlyMode()) {
    //   console.log(' Location mode - navbar disabled');
    //   return;
    // }
    let prevLocType: string;
    this.route.queryParamMap.subscribe((params: any) => {
      this.queryParams = {};
      const paramKeys = params.keys || Object.keys(params.params || {});
      paramKeys.forEach(key => {
        this.queryParams[key] = params.get ? params.get(key) : params.params[key];
      });
      if (!isNullOrUndefined(this.queryParams) && Object.keys(this.queryParams).length > 0) {
        // Drill-up via the infobox breadcrumb (to India, or District -> State) clears the selected district
        const locType = this.queryParams.locType;
        if (locType === 'COUNTRY' || (locType === 'STATE' && prevLocType === 'DISTRICT')) {
          this.selectedDistrictUUID = '';
          this.selectedDistrictName = '';
        }
        prevLocType = locType;
        // Reset selectedLocation to show placeholder when at COUNTRY or STATE level
        if (this.queryParams.locType === 'COUNTRY' || this.queryParams.locType === 'STATE') {
          this.selectedLocation = '';
        }
        this.activeHazard = this.queryParams.hazardView
        // this.activeHazard = this.queryParams.hazardView || 'earthquake';

        if (!this.isLocationOnlyMode() && !this.isLocationInfoView()) {
        this.updateOverviewConfig();
        this.updateOverviewCounts();
        }
      }
    });
    if (this.isLocationOnlyMode()) {
      return;
    }

    this.utils.nhipTimeRangeChange.subscribe(timeRange => {
      if (timeRange) {
        this.selectedTimeRange = timeRange;
        if (!this.isLocationInfoView()) {
          this.updateOverviewConfig();
          this.updateOverviewCounts();
        }
      }
    });

    this.utils.setViewForNHIPAlert.subscribe(info => {
      if (info && info.locType && info.locType === 'DISTRICT') {
        this.selectedDistrictUUID = info.districtUUID || '';
        this.selectedDistrictName = info.locName || '';
        if (!this.isLocationInfoView()) {
          this.updateOverviewConfig();
          this.updateOverviewCounts();
        }
      }
    });

    this.nhipDataSrv.cycloneStats$.subscribe(stats => {
    if (stats) {
      this.cycloneStats = stats;
      // console.log('uix Received cyclone stats:', stats);
    }
  });
    const pointHazardSubscription = this.utils.pointHazardData.subscribe(info => {
      if (info && info.latitude && info.longitude) {
        this.data.lat = info.latitude.toFixed(4);
        this.data.lng = info.longitude.toFixed(4);
      }
    });
    this.subscriptions.push(pointHazardSubscription);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
    isLocationOnlyMode(): boolean {
    return this.route.snapshot.queryParams['locationOnly'] === 'true';
  }

  // Location Info view is point-query only, so the area count APIs are skipped there
  isLocationInfoView(): boolean {
    return this.route.snapshot.queryParams['hazardView'] === 'locationInfo';
  }
  updateOverviewConfig() {
        if (this.isLocationOnlyMode()) return;

    const locType = this.getEffectiveLocTypeUpper();
    this.overviewConfig.forEach(card => {
      if (card.key === 'earthquakes' || card.key === 'cyclones') {
        card.subText = this.selectedTimeRange;
      }
    });

    const affectedTitle =
      locType === 'STATE' ? 'Most Effected District' :
      locType === 'DISTRICT' ? 'Most Effected' :
      'Most Effected State';

    this.overviewConfig.forEach(card => {
      if (card.key === 'states' || card.key === 'districts') {
        card.title = affectedTitle;
      }
    });
  }

  updateOverviewCounts() {
        if (this.isLocationOnlyMode()) return;

    const locType = this.getEffectiveLocTypeUpper();
// if (locType === 'COUNTRY') {
//       return;
//     }
//     const selectedUUID = this.getEffectiveLocUUID();
//     if (!selectedUUID) {
//       return;
//     }
//     this.getEarthquakeCount(selectedUUID);
//     this.getCycloneCount(selectedUUID);
    // Always fetch effected counts for all location types
    this.getEffectedCountEarthquake();
    this.getEffectedCountCyclone();
  }

  getEarthquakeCount(pUUID: string) {
        if (this.isLocationOnlyMode()) return;

    const { startTs, endTs } = this.getEarthquakeEpochRange();
    const postData = {
      pUUID: pUUID,
      hazardType: 'EarthQuake',
      pType: this.getEffectiveLocTypeUpper(),
      startTs: startTs,
      endTs: endTs
    };
    this.nhipDataSrv.getEarthquakeHazardData(postData).subscribe(res => {
      const data = (res && res.earthquakes) ? res.earthquakes : [];
      this.earthquakeCount = data.length;
      const card = this.overviewConfig.find(c => c.key === 'earthquakes');
      if (card) {
        card.value = this.earthquakeCount;
      }
    });
  }

  getCycloneCount(pUUID: string) {
        if (this.isLocationOnlyMode()) return;
    const { startYear, endYear } = this.getYearRange();
    const postData = {
      pUUID: pUUID,
      hazardType: 'CYCLONE',
      startTs: startYear.toString(),
      endTs: endYear.toString(),
      locType: this.getEffectiveLocTypeLower()
    };
    this.nhipDataSrv.getHazardData(postData).subscribe(response => {
      // console.log(response,"responseeeeeeeee");

      const hazardData = Array.isArray(response) ? response : (response && response.data ? response.data : []);
      const filtered = hazardData ? this.filterDataByTimeRange(hazardData) : [];
      this.cycloneCount = this.getCycloneGroupCount(filtered);
      const card = this.overviewConfig.find(c => c.key === 'cyclones');
      if (card) {
        card.value = this.cycloneCount;
      }
    });
  }
  getEffectedCountEarthquake() {
        if (this.isLocationOnlyMode()) return;

    const locType = this.getEffectiveLocTypeUpper();
    const { startYear, endYear } = this.getYearRange();

    const postData: any = {
      "pEUUID": "00cb31c7-2928-4e6d-adcc-443d478c90d6",
      "pUUID": this.getEffectiveLocUUID() || "00cb31c7-2928-4e6d-adcc-443d478c90d6",
      "pType": locType,
      "cType": locType === 'COUNTRY' ? 'STATE' : 'DISTRICT',
      "startTs": startYear.toString(),
      "endTs": endYear.toString(),
      "hazardType": "EARTHQUAKE",
      "locType": locType === 'COUNTRY' ? 'STATE' : 'district'
    };

    this.nhipDataSrv.getEffectedCount(postData).subscribe(response => {
      // console.log("response getEffectedCountEarthquake", response);

      const card = this.overviewConfig.find(c => c.key === 'earthquakes');
      const affectedCard = this.overviewConfig.find(c => c.key === 'states');

      if (response && response.totalHazardCount !== undefined && response.totalHazardCount !== null) {
        // Use totalHazardCount from response
        if (card) {
          card.value = response.totalHazardCount > 0 ? response.totalHazardCount : '-';
        }

        // Update most affected state/district card
        if (affectedCard) {
          affectedCard.value = response.mostAffected || '-';
        }
      } else {
        // Handle null or empty response
        if (card) {
          card.value = '-';
        }
        if (affectedCard) {
          affectedCard.value = '-';
        }
      }
    });
  }

  getEffectedCountCyclone() {
        if (this.isLocationOnlyMode()) return;

    const locType = this.getEffectiveLocTypeUpper();
    const { startYear, endYear } = this.getYearRange();

    const postData: any = {
      "pEUUID": "00cb31c7-2928-4e6d-adcc-443d478c90d6",
      "pUUID": this.getEffectiveLocUUID() || "00cb31c7-2928-4e6d-adcc-443d478c90d6",
      "pType": locType,
      "cType": locType === 'COUNTRY' ? 'STATE' : 'DISTRICT',
      "startTs": startYear.toString(),
      "endTs": endYear.toString(),
      "hazardType": "CYCLONE",
      "locType": locType === 'COUNTRY' ? 'STATE' : 'district'
    };

    this.nhipDataSrv.getEffectedCount(postData).subscribe(response => {
      // console.log("response getEffectedCountCyclone468", response);

      const card = this.overviewConfig.find(c => c.key === 'cyclones');
      const affectedCard = this.overviewConfig.find(c => c.key === 'districts');

      if (response && response.totalHazardCount !== undefined && response.totalHazardCount !== null) {
        // Use totalHazardCount from response
        // console.log(response,"respobse @123");

        if (card) {
          card.value = response.totalHazardCount > 0 ? response.totalHazardCount : '-';
        }

        // Update most affected state/district card
        if (affectedCard) {
          affectedCard.value = response.mostAffected || '-';
        }
      } else {
        // Handle null or empty response
        if (card) {
          card.value = '-';
        }
        if (affectedCard) {
          affectedCard.value = '-';
        }
      }

      // Fetch state-level cyclone count if at STATE level
      if (locType === 'STATE') {
        this.getStateLevelCycloneCount();
      } else {
        this.stateLevelCycloneCount = null;
      }
    });
  }

  getStateLevelCycloneCount() {
        if (this.isLocationOnlyMode()) return;

    const { startYear, endYear } = this.getYearRange();
    const selectedLocUUID = this.getEffectiveLocUUID();

    const postData = {
      "pUUID": selectedLocUUID,
      "hazardType": "CYCLONE",
      "startTs": startYear.toString(),
      "endTs": endYear.toString(),
      "locType": "state"
    };

    this.nhipDataSrv.getHazardData(postData).subscribe(response => {
      // console.log(response,"response ");

      const hazardData = Array.isArray(response) ? response : (response && response.data ? response.data : []);
      if (!hazardData || hazardData.length === 0) {
        this.stateLevelCycloneCount = 0;
        return;
      }
      const filtered = hazardData ? this.filterDataByTimeRange(hazardData) : [];
      this.stateLevelCycloneCount = this.getCycloneGroupCount(filtered);
    }, error => {
      this.stateLevelCycloneCount = null;
    });
  }

  getStateLevelCycloneDisplay(): string | number {
        if (this.isLocationOnlyMode()) return;

    if (this.stateLevelCycloneCount === null) {
      return '-';
    }
    return this.stateLevelCycloneCount;
  }

  calculateTotalFromLocWiseCount(locWiseCount: { [key: string]: number }): number {
        if (this.isLocationOnlyMode()) return;

    if (!locWiseCount) {
      return 0;
    }
    return Object.values(locWiseCount).reduce((sum, count) => sum + count, 0);
  }


getCycloneGroupCount(data: any[]): number {
      if (this.isLocationOnlyMode()) return;

    if (!data || data.length === 0) {
      return 0;
    }
    const filteredData = data.filter(item => item.hazardName !== "--");
    const grouped = this.groupBy(filteredData, 'cycloneUUID');
    return Object.keys(grouped).length;
}



  groupBy(array: any[], property: string): { [key: string]: any[] } {
        if (this.isLocationOnlyMode()) return;

    return array.reduce((acc, obj) => {
      const key = obj[property];
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(obj);
      return acc;
    }, {});
  }

  getYearRange(): { startYear: number, endYear: number } {
        if (this.isLocationOnlyMode()) return;

    const currentYear = new Date().getFullYear();
    let startYear: number;
    let endYear: number = currentYear;

    switch (this.selectedTimeRange) {
      case 'Last 10 Years':
        startYear = currentYear - 10;
        break;
      case 'Last 20 years':
        startYear = currentYear - 20;
        break;
      case 'All Historical':
        startYear = 1980;
        break;
      default:
        startYear = currentYear - 10;
    }
    return { startYear, endYear };
  }

  getEarthquakeEpochRange() {
        if (this.isLocationOnlyMode()) return;

    const { startYear, endYear } = this.getYearRange();
    return {
      startTs: new Date(startYear, 0, 1).getTime(),
      endTs: new Date(endYear, 11, 31, 23, 59, 59).getTime()
    };
  }

  filterDataByTimeRange(data: any[]): any[] {
        if (this.isLocationOnlyMode()) return;

    const { startYear, endYear } = this.getYearRange();
    return data.filter(item => {
      if (item.eventTime) {
        const eventDate = new Date(item.eventTime);
        const eventYear = eventDate.getFullYear();
        return eventYear >= startYear && eventYear <= endYear;
      }
      return false;
    });
  }

  getEffectiveLocUUID(): string {
        if (this.isLocationOnlyMode()) return;

    if (this.getEffectiveLocTypeUpper() === 'DISTRICT' && this.selectedDistrictUUID) {
      return this.selectedDistrictUUID;
    }
    if (this.queryParams && this.queryParams.pUUID) {
      return this.queryParams.pUUID;
    }
    if (this.selectedLocation) {
      return this.selectedLocation.split('##')[1];
    }
    return '';
  }

  getEffectiveLocTypeUpper(): string {
        if (this.isLocationOnlyMode()) return;

    if (this.queryParams && this.queryParams.locType === 'STATE' && this.selectedDistrictUUID) {
      return 'DISTRICT';
    }
    if (this.queryParams && this.queryParams.locType) {
      return this.queryParams.locType;
    }
    return 'COUNTRY';
  }

  getEffectiveLocTypeLower(): string {
        if (this.isLocationOnlyMode()) return;

    const upper = this.getEffectiveLocTypeUpper();
    return upper ? upper.toLowerCase() : 'country';
  }

  getBreadcrumbParts(): string[] {
        if (this.isLocationOnlyMode()) return;

    if (!this.queryParams || !this.queryParams.location) {
      return [];
    }
    return this.queryParams.location.split('&');
  }

  getStateName(): string {
        if (this.isLocationOnlyMode()) return;

    const parts = this.getBreadcrumbParts();
    return parts.length >= 2 ? parts[1].split('##')[0] : '';
  }

  getDistrictName(): string {
        if (this.isLocationOnlyMode()) return;

    const parts = this.getBreadcrumbParts();
    return parts.length >= 3 ? parts[2].split('##')[0] : '';
  }

  getOverviewTitle(): string {
        if (this.isLocationOnlyMode()) return;

    const locType = this.getEffectiveLocTypeUpper();
    if (locType === 'STATE') {
      return `${this.getStateName()} Hazard Overview`;
    }
    if (locType === 'DISTRICT') {
      return `${this.getEffectiveDistrictName()} Hazard Overview`;
    }
    return 'India Hazard Overview';
  }

  getOverviewSubtitle(): string {
        if (this.isLocationOnlyMode()) return;

    const locType = this.getEffectiveLocTypeUpper();
    if (locType === 'STATE') {
      return `Historical earthquake and cyclone events across ${this.getStateName()}`;
    }
    if (locType === 'DISTRICT') {
      return `Historical earthquake and cyclone events across ${this.getEffectiveDistrictName()}`;
    }
    return 'Historical earthquake and cyclone events across India';
  }

  getEffectiveDistrictName(): string {
        if (this.isLocationOnlyMode()) return;

    if (this.selectedDistrictName) {
      return this.selectedDistrictName;
    }
    const districtName = this.getDistrictName();
    return districtName ? districtName : '';
  }

  shouldShowOverviewCards(): boolean {
    if (this.isLocationOnlyMode()) return;

    const locType = this.getEffectiveLocTypeUpper();
    // Hide cards at district level
    return locType !== 'DISTRICT';
  }

  selectHazard(type: string) {
    this.activeHazard = type;
    let options = {... this.queryParams }
    options['hazardView'] = this.activeHazard
    // this.gisMapComp.params['actionType'] = 'filter'
    this.router.navigate(['.'],{
      relativeTo: this.route,
      queryParams: options,
      queryParamsHandling: 'merge'
    })
  }

  formatLatLng(type: string) {
    if (type === 'latitude') {
      if (this.data.lat) {
        let lat = parseFloat(this.data.lat);
        if (isNaN(lat) || lat < -90 || lat > 90) {
          this.data.lat = '';
        } else {
          this.data.lat = lat.toFixed(4);
        }
      }
    } else if (type === 'longitude') {
      if (this.data.lng) {
        let lng = parseFloat(this.data.lng);
        if (isNaN(lng) || lng < -180 || lng > 180) {
          this.data.lng = '';
        } else {
          this.data.lng = lng.toFixed(4);
        }
      }
    }
  }

  submitCoordinates() {
    if (this.data.lat && this.data.lng) {
      const lat = parseFloat(this.data.lat);
      const lng = parseFloat(this.data.lng);
      if (!isNaN(lat) && !isNaN(lng)) {
        this.nhipMapSrv.addTemporaryPointMarker(lat, lng, this.gisMapComp);
        this.gisMapComp.map.flyTo([lat, lng], 8, {
          duration: 1.5
        });
        this.nhipMapSrv.queryHazardsByPoint(lat, lng, this.gisMapComp);
      }
    }
  }

  resetCoordinates() {
    this.data.lat = '';
    this.data.lng = '';
    this.nhipMapSrv.clearAllConnectionLines(this.gisMapComp);
    if (this.gisMapComp.layers.overlaylayers['clickedPointMarker']) {
      this.gisMapComp.map.removeLayer(this.gisMapComp.layers.overlaylayers['clickedPointMarker']);
      delete this.gisMapComp.layers.overlaylayers['clickedPointMarker'];
      this.utils.nhipInfoboxReset.next();
    }
    this.gisMapComp.map.setView(LOCATIONS_LATLNG[AgricultureMapConstants.LOCATIONS.INDIA], LOCATIONS_ZOOM[AgricultureMapConstants.LOCATIONS.INDIA])
    this.gisMapComp.dataTabToggle()
  }


}
